// SMW verify-upscale zoom (2026-10-02) for sections/digital-upload.liquid -
// see the comment above its render there. Moved out of the section unchanged
// because the section reached Shopify's 256 KB template limit.
(function () {
  if (window.__smwVerifyZoom) return;
  window.__smwVerifyZoom = true;
  var MAX_SCALE = 4;
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
  var vz, stage, imgNew, imgOrig, pctEl, scale = 1, tx = 0, ty = 0, nw = 0, nh = 0, fit = 1;

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function buildViewer() {
    if (vz) return;
    vz = el('div', 'smw-vz');
    vz.setAttribute('role', 'dialog');
    vz.setAttribute('aria-modal', 'true');
    vz.setAttribute('aria-label', 'Zoomed view of your upscaled photo');
    stage = el('div', 'smw-vz__stage');
    imgOrig = el('img', 'smw-vz__orig'); imgOrig.alt = 'Original';
    imgNew = el('img', 'smw-vz__new'); imgNew.alt = 'New version';
    stage.appendChild(imgOrig); stage.appendChild(imgNew);
    var tag = el('span', 'smw-vz__tag', 'New Version');
    var hint = el('span', 'smw-vz__hint', 'Drag to look around');
    var close = el('button', 'smw-vz__close', '&times;'); close.type = 'button'; close.setAttribute('aria-label', 'Close zoom');
    var bar = el('div', 'smw-vz__bar');
    var out = el('button', 'smw-vz__zoom', '&minus;'); out.type = 'button'; out.setAttribute('aria-label', 'Zoom out');
    pctEl = el('button', 'smw-vz__pct', '100%'); pctEl.type = 'button'; pctEl.setAttribute('aria-label', 'Toggle fit / actual size');
    var inn = el('button', 'smw-vz__zoom', '+'); inn.type = 'button'; inn.setAttribute('aria-label', 'Zoom in');
    var hold = el('button', 'smw-vz__hold', 'Hold to see original'); hold.type = 'button';
    bar.appendChild(out); bar.appendChild(pctEl); bar.appendChild(inn); bar.appendChild(hold);
    vz.appendChild(stage); vz.appendChild(tag); vz.appendChild(hint); vz.appendChild(close); vz.appendChild(bar);
    document.body.appendChild(vz);

    close.addEventListener('click', closeViewer);
    out.addEventListener('click', function () { zoomAt(scale / 1.5); });
    inn.addEventListener('click', function () { zoomAt(scale * 1.5); });
    pctEl.addEventListener('click', function () { zoomAt(Math.abs(scale - 1) < 0.01 ? fit : 1); });
    function showOrig(on) { vz.classList.toggle('is-orig', on); tag.textContent = on ? 'Original' : 'New Version'; }
    hold.addEventListener('pointerdown', function (e) { e.preventDefault(); showOrig(true); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (t) { hold.addEventListener(t, function () { showOrig(false); }); });
    hold.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    hold.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); showOrig(true); } });
    hold.addEventListener('keyup', function () { showOrig(false); });
    document.addEventListener('keydown', function (e) {
      if (vz.classList.contains('is-open') && e.key === 'Escape') { e.stopPropagation(); closeViewer(); }
    }, true);

    // Pan (one pointer) and pinch (two pointers).
    var pts = {}, last = null, pinch = null;
    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 1) { last = { x: e.clientX, y: e.clientY }; stage.classList.add('is-dragging'); }
      if (ids.length === 2) { pinch = { d: dist(), s: scale }; last = null; }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2 && pinch) {
        var a = pts[ids[0]], b = pts[ids[1]];
        zoomAt(pinch.s * dist() / pinch.d, (a.x + b.x) / 2, (a.y + b.y) / 2);
      } else if (ids.length === 1 && last) {
        tx += e.clientX - last.x; ty += e.clientY - last.y; last = { x: e.clientX, y: e.clientY }; apply();
      }
    });
    function lift(e) {
      delete pts[e.pointerId];
      var ids = Object.keys(pts);
      if (ids.length < 2) pinch = null;
      if (ids.length === 1) last = { x: pts[ids[0]].x, y: pts[ids[0]].y };
      if (!ids.length) { last = null; stage.classList.remove('is-dragging'); }
    }
    stage.addEventListener('pointerup', lift);
    stage.addEventListener('pointercancel', lift);
    function dist() { var ids = Object.keys(pts), a = pts[ids[0]], b = pts[ids[1]]; return Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)); }
    stage.addEventListener('wheel', function (e) { e.preventDefault(); zoomAt(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY); }, { passive: false });
    stage.addEventListener('dblclick', function (e) { zoomAt(scale < 0.99 ? 1 : scale * 2, e.clientX, e.clientY); });
    window.addEventListener('resize', function () { if (vz.classList.contains('is-open')) { computeFit(); zoomAt(scale); } });
  }

  function computeFit() { fit = Math.min(1, stage.clientWidth / nw, stage.clientHeight / nh); }

  function apply() {
    var W = stage.clientWidth, H = stage.clientHeight, w = nw * scale, h = nh * scale;
    tx = w <= W ? (W - w) / 2 : Math.min(0, Math.max(W - w, tx));
    ty = h <= H ? (H - h) / 2 : Math.min(0, Math.max(H - h, ty));
    var t = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    imgNew.style.transform = t; imgOrig.style.transform = t;
    pctEl.textContent = Math.round(scale * 100) + '%';
  }

  // Zoom to `next`, keeping the point under (cx, cy) fixed (default: stage centre).
  function zoomAt(next, cx, cy) {
    next = Math.max(fit, Math.min(MAX_SCALE, next));
    var r = stage.getBoundingClientRect();
    var px = (cx == null ? r.width / 2 : cx - r.left), py = (cy == null ? r.height / 2 : cy - r.top);
    tx = px - (px - tx) * next / scale; ty = py - (py - ty) * next / scale; scale = next;
    apply();
  }

  function openViewer() {
    var after = document.getElementById('verifyUpscaleAfterImg');
    var before = document.getElementById('verifyUpscaleBeforeImg');
    if (!after || !after.src) return;
    buildViewer();
    function go() {
      nw = after.naturalWidth; nh = after.naturalHeight;
      if (!nw || !nh) return;
      imgNew.src = after.currentSrc || after.src;
      imgOrig.src = before ? (before.currentSrc || before.src) : '';
      [imgNew, imgOrig].forEach(function (i) { i.style.width = nw + 'px'; i.style.height = nh + 'px'; });
      vz.classList.remove('is-orig');
      vz.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      computeFit();
      // Open at actual size (1:1 pixels), centred - that is where the extra detail shows.
      scale = 1; tx = (stage.clientWidth - nw) / 2; ty = (stage.clientHeight - nh) / 2; apply();
      vz.querySelector('.smw-vz__close').focus();
    }
    if (after.complete && after.naturalWidth) go(); else after.addEventListener('load', go, { once: true });
  }

  function closeViewer() {
    if (!vz) return;
    vz.classList.remove('is-open', 'is-orig');
    document.documentElement.style.overflow = '';
    var b = document.querySelector('#verifyUpscaleModal .smw-vz-btn');
    if (b) b.focus();
  }

  function enhance(modal) {
    var compare = modal.querySelector('#verifyUpscaleCompare');
    var after = modal.querySelector('#verifyUpscaleAfterImg');
    if (!compare || !after || compare.__smwVz) return;
    compare.__smwVz = true;

    // 1. Box takes the photo's shape.
    function setRatio() { if (after.naturalWidth && after.naturalHeight) compare.style.setProperty('--smw-ar', after.naturalWidth / after.naturalHeight); }
    after.addEventListener('load', setRatio);
    setRatio();

    // 2. Zoom button. Its own mousedown/touchstart must not reach the slider's container listener.
    var btn = el('button', 'smw-vz-btn', ICON + '<span>Zoom</span>');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Zoom in on the new version');
    ['mousedown', 'touchstart', 'pointerdown'].forEach(function (t) { btn.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true }); });
    btn.addEventListener('click', function (e) { e.stopPropagation(); openViewer(); });
    compare.appendChild(btn);

    // 3. Phones: a touch anywhere on the image moves the slider - reuse the existing
    // mouse path (container mousedown sets the position and starts the drag; the existing
    // window touchmove / touchend listeners carry it on and end it).
    compare.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      if (!t || e.touches.length > 1) return;
      compare.dispatchEvent(new MouseEvent('mousedown', { clientX: t.clientX, clientY: t.clientY, bubbles: false }));
    }, { passive: true });

    // 4. Before | After zoom panes (the Framefox pattern): the same spot of both images at the
    // upscaled image's real pixel size, following the pointer / finger over the photo.
    var before = modal.querySelector('#verifyUpscaleBeforeImg');
    var wrap = el('div', 'smw-cmp-wrap');
    compare.parentNode.insertBefore(wrap, compare);
    wrap.appendChild(compare);
    var panes = el('div', 'smw-panes',
      '<div class="smw-pane"><img alt="" class="smw-pane__img smw-pane__b"><span class="smw-pane__tag">Before</span></div>' +
      '<div class="smw-pane"><img alt="" class="smw-pane__img smw-pane__a"><span class="smw-pane__tag smw-pane__tag--a">After</span></div>' +
      '<p class="smw-panes__hint"></p>');
    wrap.appendChild(panes);
    var lens = el('span', 'smw-lens');
    compare.appendChild(lens);
    var pb = panes.querySelector('.smw-pane__b'), pa = panes.querySelector('.smw-pane__a');
    panes.querySelector('.smw-panes__hint').textContent = window.matchMedia('(hover: hover)').matches
      ? 'Move over the photo to compare the detail' : 'Tap or drag on the photo to compare the detail';
    var fx = 0.5, fy = 0.5;
    function renderPanes() {
      var W = after.naturalWidth, H = after.naturalHeight;
      if (!W || !H || !before) return;
      if (pb.src !== before.src) pb.src = before.src;
      if (pa.src !== after.src) pa.src = after.src;
      [pb, pa].forEach(function (im) {
        var pw = im.parentNode.clientWidth, ph = im.parentNode.clientHeight;
        var x = Math.min(0, Math.max(pw - W, pw / 2 - fx * W)), y = Math.min(0, Math.max(ph - H, ph / 2 - fy * H));
        im.style.width = W + 'px'; im.style.height = H + 'px';
        im.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      lens.style.left = (fx * 100) + '%'; lens.style.top = (fy * 100) + '%';
    }
    function focusAt(cx, cy) {
      var r = compare.getBoundingClientRect();
      if (!r.width || !r.height) return;
      fx = Math.max(0, Math.min(1, (cx - r.left) / r.width));
      fy = Math.max(0, Math.min(1, (cy - r.top) / r.height));
      renderPanes();
    }
    compare.addEventListener('mousemove', function (e) { focusAt(e.clientX, e.clientY); });
    ['touchstart', 'touchmove'].forEach(function (t) {
      compare.addEventListener(t, function (e) { var p = e.touches[0]; if (p) focusAt(p.clientX, p.clientY); }, { passive: true });
    });
    after.addEventListener('load', function () { fx = fy = 0.5; renderPanes(); });
    if (before) before.addEventListener('load', renderPanes);
    window.addEventListener('resize', renderPanes);
    // Re-centre each time the popup opens (renderPanes writes only pane / lens styles, not the modal).
    new MutationObserver(function () {
      if (modal.classList.contains('is-visible')) { fx = fy = 0.5; requestAnimationFrame(renderPanes); }
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    renderPanes();
  }

  function check() { var m = document.getElementById('verifyUpscaleModal'); if (m) enhance(m); return !!m; }
  if (!check()) {
    var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
    function start() { mo.observe(document.body, { childList: true }); check(); }
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
})();
